import {TimespanCategory} from '@pluto/rest';
import {curry} from 'ramda';

interface MenuItem {
    label: string;
    value: number;
}

export interface MenuItems {
    group?: string;
    items: MenuItem[];
}

export enum QCIssueTypes {
    VideoIssues = 'VIDEO ISSUES',
    CaptionIssues = 'CAPTION ISSUES',
    OtherIssues = 'OTHER ISSUES',
}

const isVideoIssue = (type: TimespanCategory) => type.group?.toUpperCase() === QCIssueTypes.VideoIssues;

const isCaptionsIssue = (type: TimespanCategory) => type.group?.toUpperCase() === QCIssueTypes.CaptionIssues;

const isOtherIssue = (type: TimespanCategory) => type.group?.toUpperCase() === QCIssueTypes.OtherIssues;

const mapCategory = (category: TimespanCategory): MenuItem => {
    const {id, label} = category;
    return {
        label,
        value: id,
    };
};

export const getQCReportMenuItems = (categories: TimespanCategory[]): MenuItems[] => {
    const videoItems = categories.filter(isVideoIssue).map(mapCategory);
    const captionItems = categories.filter(isCaptionsIssue).map(mapCategory);
    const otherItems = categories.filter(isOtherIssue).map(mapCategory);
    
    const menuItems = [];
    
    if (videoItems.length > 0) {
        menuItems.push({
            group: QCIssueTypes.VideoIssues,
            items: videoItems,
        });
    }
    
    if (captionItems.length > 0) {
        menuItems.push({
            group: QCIssueTypes.CaptionIssues,
            items: captionItems,
        });
    }
    
    if (otherItems.length > 0) {
        menuItems.push({
            group: QCIssueTypes.OtherIssues,
            items: otherItems,
        });
    }
    
    return menuItems;
};

export const getMarkupMenuItems = (categories: TimespanCategory[]): MenuItems[] => {
    return [
        {
            items: categories.map(mapCategory),
        },
    ];
};

export const sameCategory = curry((id: number | undefined, category: TimespanCategory) => {
    return category.id === id;
});

export const getCategoryLabel = (id: number | undefined, categories: TimespanCategory[], defaultLabel: string) => {
    if (id === undefined || id === null) {
        return defaultLabel;
    }
    
    const compareCategory = sameCategory(id);
    const match = categories.find(compareCategory);
    
    return match ? match.label : defaultLabel;
};
